import { API_URL } from '../utils/constants';
import fetchWithTimeout from './fetchWithTimeout';

/**
 * Retourne tous les stockages
 * @param {String} token Le token d'admin de l'user connecté
 * @returns array de tous les stockages
 */
export async function getStockages(token, { limit = 5000, offset = 0 } = {}) {
  const stockages = await fetchWithTimeout(
    `${API_URL}stockages?limit=${limit}&offset=${offset}`,
    {
      headers: { 'Content-Type': 'application/json', 'auth-token': token },
    }
  );
  return stockages;
}

/**
 * Retourne un stockage
 * @param {String} id L'identifiant du stockage
 * @param {String} token Le token d'admin de l'user connecté
 * @returns le stockage désiré, ou une erreur
 */
export async function getStockage(id, token) {
  const stockage = await fetchWithTimeout(`${API_URL}stockages/${id}`, {
    headers: { 'Content-Type': 'application/json', 'auth-token': token },
  });
  return stockage;
}

/**
 * Crée un nouveau stockage
 * @param {Object} body L'objet stockage avec le champ nom
 * @param {String} token Le token d'admin de l'user connecté
 * @returns Le nouveau stockage créé, ou une erreur
 */
export async function createStockage(body, token) {
  const stockage = await fetchWithTimeout(`${API_URL}stockages/`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'auth-token': token },
    body: JSON.stringify(body),
  });
  return stockage;
}

/**
 * Modifie un stockage existant
 * @param {String} id L'identifiant du stockage
 * @param {Object} body L'objet stockage avec le champ nom
 * @param {String} token Le token d'admin de l'user connecté
 * @returns Le stockage mis à jour, ou une erreur
 */
export async function editStockage(id, body, token) {
  const stockage = await fetchWithTimeout(`${API_URL}stockages/${id}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', 'auth-token': token },
    body: JSON.stringify(body),
  });
  return stockage;
}

/**
 * Supprime un stockage
 * @param {String} id L'identifiant du stockage
 * @param {String} token Le token d'admin de l'user connecté
 * @returns rien, ou une erreur
 */
export async function deleteStockage(id, token) {
  const stockage = await fetchWithTimeout(`${API_URL}stockages/${id}`, {
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', 'auth-token': token },
  });
  return stockage;
}
